export const config = {
    appname: 'splus',
    client_id: '320639158447301', // App ID
    facebook_app_id: '320639158447301', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    api: 'apisps2',
    agency_id: '8414',
    bzbsUrl: 'https://apisps2.buzzebees.com',
    bzbsModuleUrl: 'https://splusmodule.buzzebees.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule27.buzzebees.com',
    webShoppingCartUrl: 'https://shoppingcartservice27.buzzebees.com',
    bzbsBlobUrl: 'https://buzzebees.blob.core.windows.net',
    miscUrl: 'https://misc.buzzebees.com',
    authSofin: 'https://splus.s-sofin.com/',
    webSofinUrl: 'https://splus.s-sofin.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
    cateIdNotification: {
        catActivityId: 24407,
        catNewsId: 24406,
        catProductId: 24405,
        catPrivilegeId: 24404,
        catRewardId: 31030,
    },
    firebase: {
        apiKey: "AIzaSyDayXTEmxrjjfNDXISKEwoTi_tr-Ywswms",
        authDomain: "splus-production.firebaseapp.com",
        databaseURL: "https://splus-production.firebaseio.com",
        projectId: "splus-production",
        storageBucket: "splus-production.appspot.com",
        messagingSenderId: "228044229700",
        appId: "1:228044229700:web:a7df904c89eee76bb34011",
        measurementId: "G-KT5KSFGN77"
    },
};
